import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { BottomDrawer } from 'components';
import { Container } from 'layouts/DrawerLayout/DrawerLayout.style';
import ErrorPage from 'pages/Error/Error';
import { ErrorEnum } from 'pages/Error/Error.type';
import React, { PropsWithChildren } from 'react';

const ErrorBoundary: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
    const currentTime = new Date().toTimeString().substr(0, 8);
    return (
        <SentryErrorBoundary
            // showDialog={true} // ⬅ Show a Sentry dialog for user feedback
            fallback={({ error }) => {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error';
                return (
                    <Container>
                        <BottomDrawer>
                            <ErrorPage
                                error={ErrorEnum.UNKNOWN_ERROR}
                                errorMessage={`${currentTime} - ${errorMessage}`}
                            />
                        </BottomDrawer>
                    </Container>
                );
            }}
        >
            {children}
        </SentryErrorBoundary>
    );
};

export default ErrorBoundary;
